export default function () {
    return {
        restrict: 'A',
        require: '^tab',
        link: function link(scope, elm) {
            scope.$watch('headingElement', function (heading) {
                if (heading) {
                    elm.html('');
                    elm.append(heading);
                }
            });
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/tabs/directives/TabHeading.js
// module id = 1156
// module chunks = 0